import React, { FC } from 'react'
import Button, { ButtonVariants } from './Button'
import { useStoreActions, useStoreState } from '@mortgage-pos/ui/store'

interface NavigationButtonProps {
  disabled?: boolean
  modifierClass?: string
  onClick?: (e?: React.SyntheticEvent) => void
}

const NavigationButtons: FC<NavigationButtonProps> = ({
  onClick,
  disabled,
  modifierClass,
}) => {
  const { isStart, pageIndex, active, pages } = useStoreState(
    (state) => state.questionnaire
  )

  const previousPage = pageIndex > 0 && pages[pageIndex - 1]
  const { back, next } = useStoreActions((state) => state.questionnaire)

  return (
    <div
      className={`navigation-button__container ${isStart ? '--isStart' : ''}`}
    >
      {!isStart && previousPage?.name !== 'createAccount' ? (
        <Button
          onClick={(e) => {
            back(e)
            onClick(e)
          }}
          variant={ButtonVariants.back}
        />
      ) : null}

      {active && active.allowSkip ? (
        <Button
          onClick={(e) => {
            next()
            onClick(e)
          }}
          variant={ButtonVariants.skip}
        />
      ) : null}

      <Button
        className={`--continue ${modifierClass ? modifierClass : ''}`}
        variant={ButtonVariants.next}
        type="submit"
        onClick={onClick}
        content={active ? active.nextButtonText : null}
        pageIndex={pageIndex}
        disabled={!!disabled}
      />
    </div>
  )
}

export default NavigationButtons
